export default "__VITE_ASSET__85cc5517__"